import React, { Component } from "react";
import Modal from "@material-ui/core/Modal";
import axios from "axios";
import myConfig from "../../configs/config";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { FaDrawPolygon, FaTimes, FaSave, FaEraser } from "react-icons/fa";
import "./Operation.css";
import "./CreateLandplotModal.css";
import { LAND_PLOT_MAP_STYLE } from "../../utils/mapMeasurements";

class CreateLandplotModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      landplotName: "",
      drawing: false,
      polygon: null,
      drawingManager: null,
    };

    this.mapRef = React.createRef();
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      // Modal foi aberto
      console.log("Modal de criar talhão foi aberto");
      setTimeout(() => {
        this.initMap();
      }, 100);
    }
  }

  initMap() {
    if (!this.mapRef.current || !window.google) return;

    const google = window.google;
    const { map } = this.props;

    // Calcula o centro do mapa baseado nas linhas da operação
    let center = { lat: -15.7939, lng: -47.8828 }; // Centro padrão (Brasília)

    if (map && map.lines && map.lines.length > 0) {
      const allPoints = map.lines.reduce(
        (acc, line) => acc.concat(line.path),
        [],
      );
      if (allPoints.length > 0) {
        const sumLat = allPoints.reduce((sum, point) => sum + point.lat, 0);
        const sumLng = allPoints.reduce((sum, point) => sum + point.lng, 0);
        center = {
          lat: sumLat / allPoints.length,
          lng: sumLng / allPoints.length,
        };
      }
    }

    // Cria o mapa
    const gmap = new google.maps.Map(this.mapRef.current, {
      center: center,
      zoom: 14,
      mapTypeId: "satellite",
    });

    // Desenha as linhas da operação no mapa
    if (map && map.lines) {
      map.lines.forEach((line) => {
        new google.maps.Polyline({
          path: line.path,
          geodesic: true,
          strokeColor: line.color,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          map: gmap,
        });
      });
    }

    // Desenha os talhões existentes no mapa
    if (this.props.landplots && this.props.landplots.length > 0) {
      this.props.landplots.forEach((landplot) => {
        if (landplot.path) {
          new google.maps.Polygon({
            paths: landplot.path,
            strokeColor: LAND_PLOT_MAP_STYLE.strokeColor,
            strokeOpacity: LAND_PLOT_MAP_STYLE.strokeOpacity,
            strokeWeight: LAND_PLOT_MAP_STYLE.strokeWeight,
            fillColor: LAND_PLOT_MAP_STYLE.fillColor,
            fillOpacity: LAND_PLOT_MAP_STYLE.fillOpacity,
            map: gmap,
          });
        }
      });
    }

    // Adiciona ferramenta de desenho
    const drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: null,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [google.maps.drawing.OverlayType.POLYGON],
      },
      polygonOptions: {
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35,
        editable: true,
        draggable: true,
      },
    });

    drawingManager.setMap(gmap);

    // Evento quando um polígono é desenhado
    google.maps.event.addListener(
      drawingManager,
      "overlaycomplete",
      (event) => {
        if (event.type === google.maps.drawing.OverlayType.POLYGON) {
          // Remove o polígono anterior se existir
          if (this.state.polygon) {
            this.state.polygon.setMap(null);
          }

          // Armazena o novo polígono
          this.setState({ polygon: event.overlay });

          // Desabilita o modo de desenho após criar o polígono
          drawingManager.setDrawingMode(null);
        }
      },
    );

    this.setState({ drawingManager });
    this.gmap = gmap;
  }

  handleSave() {
    const { landplotName, polygon } = this.state;

    if (!landplotName.trim()) {
      toast.error(this.props.t("Por favor, informe o nome do talhão"), {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }

    if (!polygon) {
      toast.error(this.props.t("Por favor, desenhe o perímetro do talhão"), {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }

    // Obtém as coordenadas do polígono
    const path = polygon.getPath();
    const coordinates = [];

    for (let i = 0; i < path.getLength(); i++) {
      const point = path.getAt(i);
      coordinates.push({
        lat: point.lat(),
        lng: point.lng(),
      });
    }

    // Fecha o polígono adicionando o primeiro ponto no final
    coordinates.push(coordinates[0]);

    // Formata para o formato esperado pela API
    const area = coordinates.map((point) => `${point.lng} ${point.lat}`);

    const formData = new FormData();
    formData.append("name", landplotName);
    formData.append("area", `SRID=4326;POLYGON ((${area.join(", ")}))`);
    formData.append("farm", this.props.farmId);

    const CREATE_LANDPLOT_URL = `${myConfig.API_URL}/landplot/?farm_id=${this.props.farmId}`;

    axios({
      url: CREATE_LANDPLOT_URL,
      method: "POST",
      data: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    })
      .then((response) => {
        if (response.status === 201) {
          toast.success(
            `${this.props.t("Talhão")} ${this.props.t(
              "cadastrado com sucesso !",
            )}`,
            {
              position: "bottom-right",
              autoClose: 3000,
            },
          );

          // Limpa o estado e fecha o modal
          this.setState({
            landplotName: "",
            polygon: null,
          });

          // Recarrega a lista de talhões
          if (this.props.onLandplotCreated) {
            this.props.onLandplotCreated();
          }

          this.props.onHide();
        }
      })
      .catch((error) => {
        console.error("Erro ao criar talhão:", error);
        toast.error(
          this.props.t(
            "Erro ao criar talhão. Verifique se todos os campos estão corretos.",
          ),
          {
            position: "bottom-right",
            autoClose: 5000,
          },
        );
      });
  }

  handleClearDrawing = () => {
    if (this.state.polygon) {
      this.state.polygon.setMap(null);
      this.setState({ polygon: null });
    }
    if (this.state.drawingManager) {
      this.state.drawingManager.setDrawingMode(
        window.google.maps.drawing.OverlayType.POLYGON,
      );
    }
  };

  render() {
    console.log("CreateLandplotModal render - show:", this.props.show);

    return (
      <Modal
        aria-labelledby="create-landplot-modal-title"
        aria-describedby="create-landplot-modal-description"
        open={this.props.show}
        onClose={this.props.onHide}
      >
        <div
          className="modal-size create-landplot-modal"
          style={{
            maxWidth: "95vw",
            width: "95vw",
            padding: "20px",
            maxHeight: "98vh",
            overflowY: "auto",
          }}
        >
          <div className="x_title">
            <h2>
              <FaDrawPolygon className="mr-2" style={{ marginRight: "8px" }} />
              {this.props.t("Criar Talhão a partir da Operação")}
            </h2>
            <div className="clearfix"></div>
          </div>

          <div className="x_content">
            <div className="form-group">
              <label htmlFor="landplot-name">
                {this.props.t("Nome do Talhão")}
              </label>
              <input
                id="landplot-name"
                type="text"
                className="form-control"
                value={this.state.landplotName}
                onChange={(e) =>
                  this.setState({ landplotName: e.target.value })
                }
                placeholder={this.props.t("Digite o nome do talhão")}
                maxLength={50}
              />
            </div>

            <div className="alert alert-info">
              <i className="fa fa-info-circle"></i>{" "}
              {this.props.t(
                "Use a ferramenta de desenho no mapa para traçar o perímetro do talhão. Os trajetos da operação aparecem como referência.",
              )}
            </div>

            <div
              ref={this.mapRef}
              style={{
                width: "100%",
                height: "900px",
                marginBottom: "10px",
                border: "2px solid #ddd",
                borderRadius: "4px",
              }}
            ></div>

            {this.state.polygon && (
              <button
                type="button"
                className="btn btn-warning mb-2"
                onClick={this.handleClearDrawing}
              >
                <FaEraser style={{ marginRight: "5px" }} />
                {this.props.t("Limpar Desenho")}
              </button>
            )}

            <div className="form-group mt-3">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.props.onHide}
                style={{ marginRight: "10px" }}
              >
                <FaTimes style={{ marginRight: "5px" }} />
                {this.props.t("Cancelar")}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleSave}
              >
                <FaSave style={{ marginRight: "5px" }} />
                {this.props.t("Salvar Talhão")}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default withTranslation()(CreateLandplotModal);
